export enum LinkEntityTypesEnum {
  AUTO = 'auto',
  MANUAL = 'manual',
}
